/** Common consumer email domains, in suggestion order. */
export const COMMON_DOMAINS = [
  "gmail.com",
  "hotmail.com",
  "outlook.com",
  "yahoo.com",
  "icloud.com",
  "proton.me",
] as const

/**
 * Anticipated domain suggestions for an in-progress email.
 * Returns full-email strings (local part + "@" + domain), capped at 6.
 * Empty when: no/empty local part, more than one "@", or the domain already
 * exactly matches a common domain.
 */
export function suggestDomains(value: string): string[] {
  const at = value.indexOf("@")
  if (at < 1) return [] // needs at least one local-part char + "@"
  if (value.indexOf("@", at + 1) !== -1) return [] // more than one "@"
  const local = value.slice(0, at)
  if (/\s/.test(local)) return []
  const domainPart = value.slice(at + 1).toLowerCase()
  const domains =
    domainPart === ""
      ? [...COMMON_DOMAINS]
      : COMMON_DOMAINS.filter((d) => d.startsWith(domainPart) && d !== domainPart)
  return domains.slice(0, 6).map((d) => `${local}@${d}`)
}
